var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-initial-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-initial-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-initial-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-initial-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _c("header", { staticClass: "wkb-initial-head" }, [
                _c("h2", { attrs: { id: "wkb-initial-title" } }, [
                  _vm._v(_vm._s(_vm.modalTitle)),
                ]),
                _c("p", [_vm._v(_vm._s(_vm.modalDescription))]),
              ]),
              _c("div", { staticClass: "wkb-initial-body" }, [
                _c("div", { staticClass: "wkb-initial-panel" }, [
                  _c(
                    "div",
                    { staticClass: "wkb-initial-columns" },
                    _vm._l(_vm.starterColumns, function (column) {
                      return _c("WorkspaceEntityColumn", {
                        key: column.columnKey,
                        attrs: {
                          "column-key": column.columnKey,
                          "entity-type": column.entityType,
                          title: column.title,
                          items: _vm.buckets[column.entityType],
                          "api-client": _vm.apiClient,
                          "llm-available": _vm.llmAvailable,
                          "gene-set-semantic-search-available":
                            _vm.geneSetSemanticSearchAvailable,
                        },
                        on: {
                          add: function ($event) {
                            return _vm.onAdd(column.entityType, $event)
                          },
                          remove: function ($event) {
                            return _vm.onRemove(column.entityType, $event)
                          },
                          error: _vm.onColumnError,
                        },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "wkb-initial-context" }, [
                    _c(
                      "label",
                      { attrs: { for: "wkb-initial-context-textarea" } },
                      [
                        _vm._v(
                          " Any other context we should know about? (optional) "
                        ),
                      ]
                    ),
                    _c("textarea", {
                      attrs: {
                        id: "wkb-initial-context-textarea",
                        rows: "4",
                        placeholder:
                          "Specifying additional context will help us retrieve and explain the data that we show.",
                      },
                      domProps: { value: _vm.context },
                      on: {
                        input: function ($event) {
                          return _vm.$emit(
                            "update:context",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "wkb-initial-neighbor-wrap" }, [
                    _c(
                      "label",
                      { staticClass: "wkb-initial-neighbor-option" },
                      [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: _vm.addNeighboringNodes },
                          on: {
                            change: function ($event) {
                              return _vm.$emit(
                                "update:addNeighboringNodes",
                                $event.target.checked
                              )
                            },
                          },
                        }),
                        _c("span", [
                          _vm._v(
                            " Add neighboring nodes (otherwise only directly connecting nodes will be added) "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm.columnError
                    ? _c("p", { staticClass: "wkb-initial-error" }, [
                        _vm._v(_vm._s(_vm.columnError)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("footer", { staticClass: "wkb-initial-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-initial-reset",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("reset")
                      },
                    },
                  },
                  [_vm._v(" Reset ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-initial-build",
                    attrs: { type: "button", disabled: !_vm.starterCount },
                    on: { click: _vm.onContinue },
                  },
                  [_vm._v(" Build a KG ")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }